module.exports = __webpack_public_path__ + "0cf4ab17ed455d35f549fdcccbc7f848.svg";